import React, { useState } from "react";
import styled from "styled-components";
import { calc } from "../../../js/chips-common";

const PrizeGroup = styled.div`
  display: flex;
  cursor: pointer;
  transition-property: all;
  transition: 0.1s ease-in-out;

  &:active {
    scale: 0.95;
    opacity: 0.8;
  }

  &.disable {
    scale: 1;
    opacity: 1;
  }
`;

let interval;
let intervalMs;

export function PrizeGroups({
  prizeGroups,
  selectedPrizeGroup,
  onPrizeGroupClick,
}) {
  const [showLeftAmount, setShowLeftAmount] = useState(false);

  if (interval) {
    clearInterval(interval);
  }

  function normalizedIntervalMs() {
    const duration = 2000;
    if (intervalMs) {
      const offset = Date.now() - intervalMs;
      if (duration > offset) {
        return duration - offset;
      }
    }
    return duration;
  }

  interval = setInterval(() => {
    setShowLeftAmount(!showLeftAmount);
    intervalMs = Date.now();
  }, normalizedIntervalMs());

  return (
    <div
      style={{
        width: calc(360 - 16 * 2),
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: calc(12),
        paddingTop: calc(12),
        gap: calc(6),
        justifyContent: "flex-start",
        alignItems: "start",
        overflowY: "none",
      }}
    >
      {prizeGroups && prizeGroups.length > 0
        ? prizeGroups.map((prizeGroup, index) => (
            <PrizeGroup
              className={prizeGroup.status === 2 ? "disable" : ""}
              enabled={prizeGroup.status !== 2}
              key={`prize-group-${index}-${prizeGroup.id}`}
              style={{
                position: "relative",
                width: calc((360 - 16 * 2 - 6 * 2) / 3),
                display: "flex",
                flexDirection: "column",
                gap: calc(0),
                justifyContent: "flex-start",
              }}
              onClick={() => {
                if (prizeGroup.status !== 2) {
                  onPrizeGroupClick(prizeGroup);
                }
              }}
            >
              <img
                style={{
                  position: "relative",
                  opacity: prizeGroup.status === 2 ? 0.5 : "none",
                  transform:
                    prizeGroups.length > 3 ? "none" : "translateY(-50%)",
                  // left: prizeGroups.length > 3 ? 0 : 'none',
                  // margin: prizeGroups.length > 3 ? calc(8) : "none",
                  width: calc(24),
                  height: calc(24),
                  content:
                    prizeGroup.id === selectedPrizeGroup.id
                      ? "url(/games/fruits/assets/img-fruits-prize-check-on.png)"
                      : "url(/games/fruits/assets/img-fruits-prize-check-off.png)",
                }}
              />
              <div
                style={{
                  // opacity
                  backgroundColor: `rgba(255, 255, 255, ${
                    // selected prize group
                    prizeGroup.id === selectedPrizeGroup.id ? 1 : 0.5
                  })`,
                  overflow: "hidden",
                  marginTop: calc(-24),
                  borderRadius: calc(8),
                  border: "2px solid #FFC062",
                }}
              >
                <div
                  style={{
                    // height: "100%",
                    overflow: "hidden",
                    opacity: prizeGroup.status === 2 ? 0.5 : "none",
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      // height: prizeGroups.length > 3 ? calc(123) : "100%",
                    }}
                    src={prizeGroup.group_image_url}
                  />
                </div>

                {prizeGroup.status !== 2 ? (
                  <PrizeGroupBadge
                    prizeGroup={prizeGroup}
                    showLeftAmount={showLeftAmount}
                  />
                ) : null}

                {prizeGroup.status === 2 ? (
                  <img
                    style={{
                      position: "absolute",
                      right: 0,
                      margin: calc(8),
                      maxHeight: calc(21),
                    }}
                    src="/games/fruits/assets/img-badge-soldout.png"
                  />
                ) : null}
              </div>
            </PrizeGroup>
          ))
        : null}
    </div>
  );
}

function PrizeGroupBadge({ prizeGroup, showLeftAmount }) {
  const isSpecial = prizeGroup.opportunity_type === "special";
  const hasBadgeImage = prizeGroup.group_badge_image_url;
  const winningAmountLeft = isSpecial
    ? prizeGroup.prize_items.find((prizeItem) => prizeItem.type === 1)
        ?.winning_amount_left
    : null;
  const winningAmountLeftOnly = !hasBadgeImage && winningAmountLeft;
  const showWinningLeftAmount =
    isSpecial && winningAmountLeft && (showLeftAmount || winningAmountLeftOnly);

  return (
    <div
      style={{
        position: "absolute",
        right: 0,
        margin: calc(8),
        minHeight: calc(21),
        maxHeight: calc(21),
      }}
    >
      <img
        style={{
          position: "absolute",
          right: 0,
          maxHeight: calc(21),
          opacity: showWinningLeftAmount ? 0 : 1,
          transitionProperty: "all",
          transition: ".1s ease-in-out",
        }}
        src={prizeGroup.group_badge_image_url}
      />

      <span
        style={{
          minHeight: calc(21),
          maxHeight: calc(21),
          color: "#FFF",
          textAlign: "center",
          fontFamily: "OneMobilePop",
          fontSize: calc(12),
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "106%",
          padding: `0 ${calc(4)}`,
          boxSizing: "border-box",
          borderRadius: calc(5),
          background: "#D365F9",
          opacity: showWinningLeftAmount ? 1 : 0,
          transitionProperty: "all",
          transition: ".1s ease-in-out",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {winningAmountLeft}개 남음
      </span>
    </div>
  );
}
